// extracted by mini-css-extract-plugin
export default {"root":"V7m2svoAdFjFhtpygEBT"};